/**
 * List Collections Page – Search, sort, and sidebar navigation
 */

class ListCollectionsPage extends HTMLElement {
  constructor() {
    super();

    this.searchInput = this.querySelector('[data-search-input]');
    this.sortSelect = this.querySelector('[data-sort-select]');
    this.sidebarToggle = this.querySelector('[data-sidebar-toggle]');
    this.sidebar = this.querySelector('[data-sidebar]');
    this.sidebarLinks = this.querySelectorAll('[data-sidebar-link]');
    this.categories = this.querySelectorAll('[data-category]');
    this.cards = this.querySelectorAll('[data-collection-card]');

    this.init();
  }

  init() {
    // Search
    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => this.onSearch());
    }

    // Sort
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', () => this.onSort());
    }

    // Sidebar toggle (mobile)
    if (this.sidebarToggle && this.sidebar) {
      this.sidebarToggle.addEventListener('click', () => {
        this.sidebar.classList.toggle('is-open');
        this.sidebarToggle.classList.toggle('is-open');
      });
    }

    // Sidebar links – smooth scroll to category
    this.sidebarLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        const target = document.getElementById(targetId);

        if (target) {
          // Update active state
          this.sidebarLinks.forEach(l => l.classList.remove('is-active'));
          link.classList.add('is-active');

          // Smooth scroll
          const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
          const top = target.getBoundingClientRect().top + window.scrollY - offset - 20;
          window.scrollTo({ top, behavior: 'smooth' });

          // Close mobile sidebar
          if (this.sidebar) this.sidebar.classList.remove('is-open');
          if (this.sidebarToggle) this.sidebarToggle.classList.remove('is-open');
        }
      });
    });

    // Scroll spy – highlight active sidebar link
    if (this.categories.length > 0 && this.sidebarLinks.length > 0) {
      window.addEventListener('scroll', () => this.onScroll(), { passive: true });
    }
  }

  onSearch() {
    const query = this.searchInput.value.trim().toLowerCase();

    this.cards.forEach(card => {
      const title = card.dataset.collectionTitle || '';
      card.classList.toggle('is-hidden', query !== '' && !title.includes(query));
    });

    // Hide categories that have no visible cards
    this.categories.forEach(category => {
      const visibleCards = category.querySelectorAll('[data-collection-card]:not(.is-hidden)');
      category.classList.toggle('is-hidden', visibleCards.length === 0);
    });
  }

  onSort() {
    const value = this.sortSelect.value;
    if (value === 'default') return;

    this.categories.forEach(category => {
      const grid = category.querySelector('.list-collections__grid');
      if (!grid) return;

      const cards = Array.from(grid.querySelectorAll('[data-collection-card]'));
      cards.sort((a, b) => {
        const titleA = a.dataset.collectionTitle || '';
        const titleB = b.dataset.collectionTitle || '';
        return value === 'a-z' ? titleA.localeCompare(titleB) : titleB.localeCompare(titleA);
      });

      cards.forEach(card => grid.appendChild(card));
    });
  }

  onScroll() {
    const offset = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0) + 40;
    let activeId = null;

    this.categories.forEach(category => {
      const rect = category.getBoundingClientRect();
      if (rect.top <= offset) {
        activeId = category.id;
      }
    });

    if (activeId) {
      this.sidebarLinks.forEach(link => {
        const targetId = link.getAttribute('href').substring(1);
        link.classList.toggle('is-active', targetId === activeId);
      });
    }
  }
}

customElements.define('list-collections-page', ListCollectionsPage);
